







































































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import EmployeeApi from '@/api/employee/index.ts'
import ArticleApi from '@/api/article/index'
@Component({
  components: {
    CustomForm
  }
})
export default class ArticleList extends AbpBase {
  filters = [
    {
      label: '关键字搜索：',
      type: 'input',
      props: {
        placeholder: ''
      },
      key: 'Filter'
    },
    {
      label: '文章分类',
      type: 'select',
      key: 'Categories',
      defaultValue: [],
      props: {
        'max-tag-count': 2,
        multiple: true,
        placeholder: '请选择'
      },
      options: []
    },
    {
      label: '文章标签',
      type: 'select',
      key: 'Labels',
      defaultValue: [],
      props: {
        'max-tag-count': 2,
        multiple: true,
        placeholder: '请选择'
      },
      options: []
    }
  ]
  columns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center'
    },
    {
      title: '头图',
      slot: 'picture',
      align: 'center',
      width: 80
    },
    {
      title: '文章标题',
      key: 'title',
      align: 'center'
    },
    {
      title: '所属分类',
      key: 'category',
      align: 'center'
    },
    {
      title: '相关商品数',
      key: 'productCount',
      align: 'center'
    },
    {
      title: '转发',
      key: 'forward',
      align: 'center'
    },
    {
      title: '收藏数',
      key: 'collection',
      align: 'center'
    },
    {
      title: '阅读数',
      key: 'readCount',
      align: 'center'
    },
    {
      title: '点赞数',
      key: 'thumbsUps',
      align: 'center'
    },
    {
      title: '创建时间',
      slot: 'creationTime',
      align: 'center'
    },
    {
      title: '状态',
      slot: 'isActive',
      align: 'center'
    },
    {
      title: '操作',
      slot: 'action',
      type: 'action',
      width: 150,
      align: 'center'
    }
  ]
  isCheckAll: boolean = false
  loading: boolean = false
  tableData: any[] = []
  currentPage = 1
  pageSize = 10
  totalCount = 0
  showTag = false
  tagList = []
  submitChange(form, valid) {
    if (valid) {
      this.getArticleList(form)
    }
  }

  mounted() {
    this.getCategoryList()
    this.getLabelList()
    this.submitFn()
  }

  /**
   * 获取所有文章分类
   */
  getCategoryList() {
    ArticleApi.getCategoryList().then(res => {
      this.filters.forEach(item => {
        if (item.key == 'Categories') {
          switch (item.type) {
            case 'select':
              res.data.items = res.data.items.map(child => {
                return {
                  value: child.id,
                  text: child.name
                }
              })
              item.options = res.data.items
              break
          }
        }
      })
    })
  }

  /**
   * 获取所有文章标签
   */
  getLabelList() {
    ArticleApi.getLabelList().then(res => {
      this.filters.forEach(item => {
        if (item.key == 'Labels') {
          switch (item.type) {
            case 'select':
              res.data.items = res.data.items.map(child => {
                return {
                  value: child.id,
                  text: child.name
                }
              })
              item.options = res.data.items
              break
          }
        }
      })
    })
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  /**
   * 批量设置启用禁用
   */
  BatchSetActive(active) {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      let ids = selection.map(item => {
        return item.id
      })
      ArticleApi.BatchSetActive(ids, active).then(res => {
        this.submitFn()
      })
    } else {
      this.$Modal.error({
        title: '请选择文章'
      })
    }
  }

  activeChange(row) {
    ArticleApi.BatchSetActive([row.id], row.isActive).then(res => {})
  }

  /**
   * 获取文章列表
   */
  getArticleList(form = {}) {
    this.isCheckAll = false
    let Filter = form['Filter']
    let Labels = form['Labels']
    let Categories = form['Categories']
    let { pageSize, currentPage } = this
    let published = false
    this.loading = true
    ArticleApi.getArticleList(pageSize, currentPage, Categories, Filter, Labels)
      .then(res => {
        this.loading = false
        let { totalCount, items } = res.data
        this.totalCount = totalCount
        this.tableData = items
      })
      .catch(() => {
        this.loading = false
        this.totalCount = 0
        this.tableData = []
      })
  }

  /**
   * 编辑文章信息
   */
  editArticleFn(id?) {
    this.$router.push({
      name: 'editArticle',
      query: {
        id: id
      }
    })
  }

  /**
   * 删除文章
   */
  deleteFn(id) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.loading = true
        ArticleApi.deleteArticle(id)
          .then(res => {
            this.loading = false
            this.submitFn()
          })
          .catch(err => {
            this.loading = false
          })
      }
    })
  }

  /**
   * 文章详情
   */
  goDetailFn(id) {
    this.$router.push({
      name: 'articleDetail',
      query: {
        id: id
      }
    })
  }

  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  handleSelectAll() {
    if (!this.tableData.length) return
    ;(this.$refs.selection as any).selectAll(!this.isCheckAll)
  }

  pageChange(currentPage) {
    this.currentPage = currentPage
    this.submitFn()
  }
  pageSizeChange(pageSize) {
    this.pageSize = pageSize
    this.currentPage = 1
    this.submitFn()
  }
}
